module.exports = __webpack_public_path__ + "static/70-1f6c0cb94003f126b9bd16ef686b8892.png";